import { render, staticRenderFns } from "./BasketDiscountRow.vue?vue&type=template&id=3c5f468e&"
import script from "./BasketDiscountRow.vue?vue&type=script&lang=js&"
export * from "./BasketDiscountRow.vue?vue&type=script&lang=js&"
import style0 from "./BasketDiscountRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports